import { MoneyConnectClientAPI } from "./axios-service-creator";

export const CustomerAPI = {
  getCustomerProfileCBS: () => MoneyConnectClientAPI.get("/customer/profile"),
  getCustomerProfileMNC: () => MoneyConnectClientAPI.get("/customer/profile/data"),
  getCustomerEmail: () => MoneyConnectClientAPI.get("/customer/profile/data").then((res) => res.data.result.email),
  isRegistered: () => MoneyConnectClientAPI.get("/customer/check/register"),
  isUserUHNW: () => MoneyConnectClientAPI.get("/customer/check/uhnw"),
  getCustomerAccounts: (params) => MoneyConnectClientAPI.get("/subscription/customer/accounts", { params }),
  getCustomerFCYAccounts: (params) => MoneyConnectClientAPI.get("/subscription/customer/accountsFCY", { params }),
  getGlobalCustomerAccounts: (params) => MoneyConnectClientAPI.get("/customer/profile/accounts", { params }),
  //* check that user must re-test the suitability or not ?
  suitability: () => MoneyConnectClientAPI.get("/customer/check/suitability"),
  //* answer and suitability status
  getSuitabilityData: (signal) => MoneyConnectClientAPI.get("/customer/check/suitability/data", { signal }),
  //* submit suitability test
  sendSuitabilityTest: (payload) => MoneyConnectClientAPI.post("/customer/check/suitability/test", payload),
  checkBankruptcy: () => MoneyConnectClientAPI.get("/customer/check/bankRuptcy"),
  checkCrsForPwmUser: () => MoneyConnectClientAPI.post("/consolidate/pwm/verify/crs", {}),
  checkCrsOffshoreNote: (payload) => MoneyConnectClientAPI.post("/subscription/security/check/crs", payload),
};
